import Button from "../ui/Button";
import toast from "react-hot-toast";
import { XIcon } from "@heroicons/react/solid";

const ChatNotification = ({
  firstName,
  lastName,
  message,
  avatar,
  needsAttention = false,
  onClickHandler,
  chatId,
}) => {
  const initials = `${firstName?.charAt(0).toUpperCase()}${lastName
    ?.charAt(0)
    .toUpperCase()}`;

  return toast.custom(
    (t) => (
      <div
        className={`${
          t.visible ? "animate-enter" : "animate-leave"
        } max-w-md w-full bg-white shadow-lg rounded-lg pointer-events-auto flex ring-1 ring-black ring-opacity-5 cursor-pointer ${
          needsAttention ? "ring-red-500" : ""
        }`}
        onClick={() => {
          if (onClickHandler) {
            if (chatId) {
              const url = `/chats?openChat=${chatId}`;
              onClickHandler(url);
            } else {
              onClickHandler();
            }
          }
          toast.dismiss(t.id);
        }}
      >
        <div className="flex-1 w-0 p-4">
          <div className="flex items-start">
            <div className="flex-shrink-0 pt-0.5">
              {avatar ? (
                <img
                  className="h-10 w-10 rounded-full object-cover"
                  src={avatar}
                  alt={`${firstName} ${lastName}`}
                />
              ) : (
                <div className="w-10 h-10 rounded-full bg-gray-700 text-white flex items-center text-xl justify-center font-medium">
                  {initials}
                </div>
              )}
            </div>
            <div className="ml-3 flex-1">
              <p className="text-sm font-medium text-gray-900">
                {firstName} {lastName}
              </p>
              {needsAttention ? (
                <p className="mt-1 text-sm text-red-600 font-medium flex items-center">
                  <span className="mr-1">⚠️</span> Needs your attention!
                </p>
              ) : (
                <p className="mt-1 text-sm text-gray-500">
                  {message.length > 50
                    ? `${message.substring(0, 50)}...`
                    : message}
                </p>
              )}
            </div>
          </div>
        </div>
        <div className="flex border-l border-gray-200">
          <Button
            onClick={(e) => {
              e.stopPropagation();
              toast.dismiss(t.id);
            }}
            variant={"ghost"}
            aria-label="Close notification"
            className="!h-full w-full border border-transparent rounded-none rounded-r-lg p-4 flex items-center justify-center text-sm font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
          >
            <XIcon className="h-5 w-5" />
          </Button>
        </div>
      </div>
    ),
    {
      position: "top-right",
      duration: 5000,
    }
  );
};

export default ChatNotification;
